<template>
  <v-app>
    <v-container>
      <!-- 결제 수단 : 카드 -->
      <v-card v-if="method == '카드'" outlined class="ma-5 pa-10">
        <h3 class="mb-4">카드결제</h3>
        <p>
          카드 결제가 진행중입니다.<br />
          이 창은 결제가 완료된 후 자동적으로 닫힙니다.
        </p>
      </v-card>

      <!-- 결제 오류 -->
      <v-card v-if="error" outlined class="ma-5 pa-10">
        <h3 class="mb-4">결제 오류</h3>
        <p>
          오류 코드 : {{ code }}<br />
          오류 메세지: {{ message }}
        </p>
      </v-card>
    </v-container>
  </v-app>
</template>
<script>
import { mapGetters } from "vuex"
import { PayOrderTypes } from "@/constant"
export default {
  data: () => ({
    error: false,
    method: "",
    code: "",
    message: "",
  }),

  computed: {
    ...mapGetters(["isKRW"]),
  },

  created() {
    // 중복 체크
    this.$http
      .post("/api/order/select/check_duplicate", {
        params: {
          toss_id: this.$route.query.orderId,
        },
      })
      .then((res) => {
        // 키오스크 연동 온라인 결제
        if (res.data[0].type == PayOrderTypes.OnlineConceptBuy || res.data[0].type == PayOrderTypes.OnlineAddShot) {
          this.onlinePayment(res.data[0].order_list_id, res.data[0].type)
        }
        // 무인촬영기
        else if (res.data[0].type == PayOrderTypes.OnliePhotoTouch) {
          // 정상 결제
          this.paymentAuto(res.data[0].order_list_id)
        } else {
          // 라피아캐슬
          this.$http
            .post("/api/reservation/select/specific/time/castle/check", {
              params: {
                year: res.data[0].year,
                month: res.data[0].month,
                day: res.data[0].day,
                time: res.data[0].time,
              },
            })
            .then((res2) => {
              if (res2.data.length) {
                if (res.data[0].cloth + res.data[0].uncloth + (res2.data[0].total_cloth + res2.data[0].total_uncloth) > 10) {
                  alert("결제도중 같은 타임의 예약이 발생하였습니다. 진행중인 결제는 취소됩니다.")
                  this.$router.push("/")
                } else {
                  // 정상 결제
                  this.payment(res.data[0].order_list_id)
                }
              } else {
                // 정상 결제
                this.payment(res.data[0].order_list_id)
              }
            })
        }
      })
  },

  methods: {
    // 정상 결제
    payment(orderListId) {
      let tossPayment = () => {
        return this.$http.post("/api/payments/toss/confirm", {
          orderListId,
          paymentKey: this.$route.query.paymentKey,
          orderId: this.$route.query.orderId,
          amount: Number(this.$route.query.amount),
        })
      }

      // let tossPayment = () => {
      //   return this.$http.get("/api/toss/success", {
      //     params: {
      //       paymentKey: this.$route.query.paymentKey,
      //       orderId: this.$route.query.orderId,
      //       amount: this.$route.query.amount,
      //     },
      //   })
      // }

      // 토스 결제
      tossPayment().then((res) => {
        if (res.data.status != "DONE") {
          alert("결제도중 오류가 발생하였습니다. 고객센터 문의 바랍니다.")
        } else {
          this.$router.push("/reservation/complete?id=" + this.$route.query.orderId)

          this.$gtag.purchase({
            transaction_id: this.$route.query.orderId,
            value: Number(this.$route.query.amount),
            currency: "KRW",
            items: [
              {
                item_name: res.data[0].type,
                price: Number(this.$route.query.amount),
              },
            ],
          })
        }
      })
    },

    // 정상 결제 (무인촬영기)
    paymentAuto(order_id) {
      let tossPayment = () => {
        return this.$http.post("/api/payments/toss/confirm", {
          orderListId: order_id,
          paymentKey: this.$route.query.paymentKey,
          orderId: this.$route.query.orderId,
          amount: Number(this.$route.query.amount),
        })
      }

      if (this.$route.query.paymentKey === "test") {
        tossPayment = () => {
          return new Promise((resolve, reject) => {
            resolve({ data: { status: "DONE" } })
          })
        }
      }

      tossPayment().then((res) => {
        if (res.data.status != "DONE") {
          alert("결제도중 오류가 발생하였습니다. 고객센터 문의 바랍니다.")
        } else {
          this.$http
            .post("/api/qrcode/update/status/byOrderId", {
              params: {
                order_id: order_id,
                paymentKey: this.$route.query.paymentKey,
                status: "선택완료",
              },
            })
            .then((res) => {
              alert("사진 보정요청이 완료되었습니다.")
              this.$router.push("/mypage/home?type=picture")

              this.$gtag.purchase({
                transaction_id: this.$route.query.orderId,
                value: Number(this.$route.query.amount),
                currency: "KRW",
                items: [
                  {
                    item_name: "온라인추가보정신청",
                    price: Number(this.$route.query.amount),
                  },
                ],
              })
            })
        }
      })
    },

    // 키오스크 온라인 결제 연동
    onlinePayment(order_list_id, productType) {
      let tossPayment = () => {
        return this.$http.post("/api/payments/toss/confirm", {
          orderListId: order_list_id,
          paymentKey: this.$route.query.paymentKey,
          orderId: this.$route.query.orderId,
          amount: Number(this.$route.query.amount),
        })
      }

      if (this.$route.query.paymentKey === "test") {
        tossPayment = () => {
          return new Promise((resolve, reject) => {
            resolve({ data: { status: "DONE" } })
          })
        }
      }

      tossPayment().then(async (res) => {
        if (res.data.status != "DONE") {
          alert("결제도중 오류가 발생하였습니다. 고객센터 문의 바랍니다.")
        } else {
          const result = await this.$http.post("/api/qrcode/pay/complete", {
            pay_amount: Number(this.$route.query.amount),
            orderListId: order_list_id,
            currency: "KRW",
          })
          if (result.data.affectedRows) {
            // 업데이트 완료
            // 결제가 완료되었습니다. 안내 페이지로 이동
            this.$router.push("/onlinePaySuccess?id=" + this.$route.query.orderId)
            //결제완료
            this.$gtag.purchase({
              transaction_id: this.$route.query.orderId,
              value: Number(this.$route.query.amount),
              currency: "KRW",
              items: [
                {
                  item_name: productType,
                  price: Number(this.$route.query.amount),
                },
              ],
            })
          } else {
            alert("정상적으로 결제가 처리되지 않았습니다. 관리자에게 문의해 주세요.")
          }
        }
      })
    },
  },
}
</script>
